import {
  FlexColumnContainer,
  FlexRowContainer,
  StrongText,
} from "@trailhead/core-ui";
import React from "react";
import styled from "styled-components";
import { trackEvent } from "@trailhead/analytics";
import { Button as AsurionButton, Text } from "@trailhead/asurion-ui";
import { UserChatIcon } from "../assets";
import { QuestionsCTAProps } from "./propTypes";
import { useSanitizedTranslation } from "@trailhead/i18n";
import { useChatClient } from "./useChatClient";
import { useIsChatEnabled } from "./useIsChatEnabled";

const QuestionsContainer = styled.div`
  max-width: 600px;
  margin-top: 1rem;
  padding: 16px;
  display: flex;
  flex-direction: row;
  border-radius: 8px;
  background-color: #f0f0f5;
  align-self: left;
`;

const MarginContainer = styled.div`
  margin-bottom: 1rem;
`;

const CallToAction = styled(FlexColumnContainer)`
  align-items: left;
  width: 100%;
`;

const CallToActionHeaderAndButton = styled(FlexColumnContainer)`
  max-width: 50%;
`;

const CallToActionHeader = styled(Text)`
  text-align: left;
`;

const CallToActionSubHeader = styled(Text)`
  text-align: left;
  margin-top: 5px;
`;

const ImageWrapper = styled.div`
  text-align: left;
  margin-left: auto;
`;

const AsurionButtonWrapper = styled(AsurionButton)`
  align-self: flex-start;
  margin-left: 0px;
  margin-top: 28px;
  line-height: none;
  max-height: 32px;
  max-width: 260px;
`;

export const QuestionsCTA: React.FC<QuestionsCTAProps> = ({
  content = {
    buttonText: "Start a live chat",
    title: "Have questions?",
    subtext: "Our experts can help",
  },
}) => {
  const t = useSanitizedTranslation();
  const ChatClient = useChatClient();
  const openChat = (): void => {
    trackEvent("QuestionCTAClicked");
    ChatClient.openMessagingOverlay();
  };
  const enableMessaging = useIsChatEnabled();

  return (
    <MarginContainer>
      {enableMessaging && (
        <QuestionsContainer>
          <CallToAction>
            <FlexRowContainer>
              <CallToActionHeaderAndButton>
                <StrongText>
                  <CallToActionHeader
                    size={3}
                    dangerouslySetInnerHTML={{
                      __html: t(content.title as string),
                    }}
                  />
                </StrongText>
                <CallToActionSubHeader
                  dangerouslySetInnerHTML={{
                    __html: t(content?.subtext as string),
                  }}
                />

                <AsurionButtonWrapper
                  iconSrc="ChatBubbleCircle"
                  size="medium"
                  variant="default"
                  onClick={openChat}
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: t(content?.buttonText as string),
                    }}
                  />
                </AsurionButtonWrapper>
              </CallToActionHeaderAndButton>
              <ImageWrapper>
                <UserChatIcon />
              </ImageWrapper>
            </FlexRowContainer>
          </CallToAction>
        </QuestionsContainer>
      )}
    </MarginContainer>
  );
};
